import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { ReduxInput, ReduxSwitch } from 'components/FormElements'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// views
import { Wrapper, Form } from './views'
// constants
import { Forms } from 'constants/forms'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// utils
import { maxLength, required } from 'utils/validators'

export interface AddFilterFormData {
  name: string
  global?: boolean
}

const maxLength50 = maxLength(50)

const SaveFilterForm: React.FC<InjectedFormProps<FormData>> = ({ handleSubmit, valid, submitting }) => {
  const { isRiskTemplate } = React.useContext(RiskTemplateAPIContext)

  const {
    permissionsFromSecurityGroups: { manageRiskTemplates }
  } = useCurrentUser()

  return (
    <Wrapper>
      <Form onSubmit={handleSubmit}>
        {!isRiskTemplate && <ReduxSwitch name={'global'} label={'Global'} disabled={!manageRiskTemplates} />}
        <ReduxInput name={'name'} label={'Filter Name'} validate={[required, maxLength50]} />
        <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE} type={'submit'} disabled={!valid || submitting}>
          Save
        </Button>
      </Form>
    </Wrapper>
  )
}

export default reduxForm<any, any>({ form: Forms.RISK_VIEW_ADD_FILTER_FORM })(SaveFilterForm)
